import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import hero from '../assets/images/hero/arandaplus.jpg'
import arandaintro from '../assets/images/arandaplus/mas.gif'
import arandacard from '../assets/images/arandaplus/arandacard4.png'
import icon from '../assets/images/branding/icon6.png'
import { LuBadgeCheck, LuInfo } from 'react-icons/lu'
import useCsrfToken from '../hooks/useCsrfToken'
import { Turnstile } from '@marsidev/react-turnstile'
import { setRegistrationinfo, setRegistrationerror, getRegistrationInfo } from '../slices/registrationSlice';
import { Helmet } from 'react-helmet-async';

export default function Arandaplus() {
    const { csrfToken } = useCsrfToken();
    const dispatch = useDispatch();
    const [isChecked, setIsChecked] = useState(false);
    const basedomain = process.env.REACT_APP_BASE_URL;
    const registrationInfo = useSelector(getRegistrationInfo);
    const registrationError = useSelector((state) => state.contact.error);
    const [captchaPassed, setCaptchaPassed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorDeliveringMessage, SetErrorDeliveringMessage] = useState('');
    const [errorDelivering, SetErrorDelivering] = useState(false);
    const [successDeliveringMessage, SetSuccessDeliveringMessage] = useState('');
    const [successDelivering, SetSuccessDelivering] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL;

    const TURNSTILE_KEY = '0x4AAAAAABBf7H_LASwjWDgk';

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    const handlePhoneInput = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        if (value.length > 10) {
            e.target.value = value.slice(0, 10);
        } else {
            e.target.value = value;
        }
    };

    const handleEmailInput = (e) => {
        const value = e.target.value.replace(/[^a-zA-Z0-9@._-]/g, '');
        e.target.value = value;

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(value)) {
            e.target.setCustomValidity('Por favor, ingrese una dirección de correo electrónico válida.');
        } else {
            e.target.setCustomValidity('');
        }
    };

    const handleEmailBlur = (e) => {
        console.log('handleEmailBlur');
        const value = e.target.value;
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const invalidFeedback = e.target.nextElementSibling;
        if (!emailPattern.test(value)) {
            e.target.setCustomValidity('Por favor, ingrese una dirección de correo electrónico válida.');
            invalidFeedback.style.display = 'block';
        } else {
            e.target.setCustomValidity('');
            invalidFeedback.style.display = 'none';
        }
    };


    const sanitizeInput = (value) => {
        const element = document.createElement('div');
        element.innerText = value;
        const sanitizedValue = element.innerHTML;
        return sanitizedValue.replace(/<script.*?>.*?<\/script>/gi, 'HAPHAPHAP');
    };

    const handleSanitizedInput = (e) => {
        e.target.value = sanitizeInput(e.target.value);
    };

    const InitRegistration = (data) => {
        console.log('data', data);
        dispatch(setRegistrationinfo(data));
    }

    useEffect(() => {
        // console.log('CSRF Token:', csrfToken);
    }, [csrfToken]);

    const handleSubmit = async (e) => {
        setIsLoading(true);
        e.preventDefault();
        const form = e.target;
        const formData = new FormData(form);

        const data = {
            firstname: formData.get('firstname'),
            secondname: formData.get('secondname'),
            lastname: formData.get('lastname'),
            secondlastname: formData.get('secondlastname'),
            tel: formData.get('tel'),
            email: formData.get('email'),
            email_confirmation: formData.get('email_confirmation'),
            captcharesponse: formData.get('cf-turnstile-response'),
            _token: csrfToken
        };

        InitRegistration(data);

        try {
            const response = await fetch(`${API_URL}/api/arandaplus/register`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(data),
            });

            const result = await response.json();
            if (result.status === 'success') {
                SetErrorDeliveringMessage('');
                SetErrorDelivering(false);
                SetSuccessDeliveringMessage(result.message);
                SetSuccessDelivering(true);
                dispatch(setRegistrationerror(false));
                form.reset();
                setIsLoading(false);
                setCaptchaPassed(false);
                setIsChecked(false);
            } else {
                SetErrorDeliveringMessage(result.message);
                SetErrorDelivering(true);
                SetSuccessDelivering(false);
                setIsLoading(false);
                dispatch(setRegistrationerror(true));
            }
        } catch (error) {
            SetErrorDeliveringMessage(error);
            SetErrorDelivering(true);
            SetSuccessDelivering(false);
            setIsLoading(false);
            dispatch(setRegistrationerror(true));
        }
    };

    const handleCallBackTurnstile = (data) => {
        setCaptchaPassed(true);
    }

    const handleExpirationTurnstile = () => {
        setCaptchaPassed(false);
        console.log('Turnstile - expired');
    }

    return (
        <div id='LoyaltyProgram'>
            <Helmet>
                <title>Programa de beneficios Aranda+ | Hospital Aranda de La Parra</title>
                <meta name="description" content="En Hospital Aranda de la Parra, reafirmamos nuestro compromiso de estar contigo en cada etapa de tu vida. Con nuestro programa de beneficios, obtienes descuentos especiales en farmacia, laboratorio, imagenología y más." />
                <meta property="og:title" content="Programa de beneficios Aranda+ | Hospital Aranda de La Parra" />
                <meta property="og:description" content="En Hospital Aranda de la Parra, reafirmamos nuestro compromiso de estar contigo en cada etapa de tu vida. Con nuestro programa de beneficios, obtienes descuentos especiales en farmacia, laboratorio, imagenología y más." />
                <meta property="og:image" content={`${basedomain}${hero}`} />
                <meta property="og:url" content={`${basedomain}/programa-beneficios`} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Programa de beneficios Aranda+ | Hospital Aranda de La Parra" />
                <meta name="twitter:description" content="En Hospital Aranda de la Parra, reafirmamos nuestro compromiso de estar contigo en cada etapa de tu vida. Con nuestro programa de beneficios, obtienes descuentos especiales en farmacia, laboratorio, imagenología y más." />
                <meta name="twitter:image" content={`${basedomain}${hero}`} />
                <meta itemprop="name" content="Programa de beneficios Aranda+ | Hospital Aranda de La Parra" />
                <meta itemprop="description" content="En Hospital Aranda de la Parra, reafirmamos nuestro compromiso de estar contigo en cada etapa de tu vida. Con nuestro programa de beneficios, obtienes descuentos especiales en farmacia, laboratorio, imagenología y más." />
                <meta itemprop="image" content={`${basedomain}${hero}`} />
            </Helmet>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Programa de Beneficios Aranda+</h5>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Aranda +</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>

            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>
            <section className="section bg-inverted pt-3">
                <div className="container">
                    <div className="row justify-content-center my-5">
                        <div className="col-12 col-sm-8 text-center">
                            <img src={arandaintro} alt="Aranda +" className='w-100 rounded mx-auto' />
                        </div>
                    </div>
                    <div className="row justify-content-center">

                        <div className="col-lg-7 col-12 mt-4 mt-md-0 p-4 pt-4 pt-md-0">
                            <div className="section-title text-center">
                                <h2 className="text-primary text-uppercase">Programa de Beneficios</h2>
                                <blockquote>
                                    Accede a descuentos exclusivos en salud y bienestar.
                                </blockquote>
                                <p className="para-desc text-muted">
                                    En Hospital Aranda de la Parra, reafirmamos nuestro compromiso de estar contigo en cada etapa de tu vida. Con nuestro programa de beneficios, obtienes descuentos especiales en farmacia, laboratorio, imagenología y más.
                                    Regístrate hoy y disfruta de:
                                </p>
                                <div className='text-start my-4'>
                                    <p><LuBadgeCheck /> <strong>15%</strong> de descuento en Farmacia</p>
                                    <p><LuBadgeCheck /> <strong>20%</strong> en Imagenología (excepto PET)</p>
                                    <p><LuBadgeCheck /> <strong>10%</strong> en Laboratorio</p>
                                    <p><LuBadgeCheck /> <strong>Tarifa especial</strong> en hospedaje en el Hotel Yvette</p>
                                    <p><LuBadgeCheck /> <strong>Tarifa especial</strong> en consulta de urgencias (médico general)</p>
                                    <p><LuBadgeCheck /> <strong>Promociones, descuentos y eventos exclusivos</strong> durante todo el año.</p>

                                </div>
                                <div className="small mt-5 text-muted text-start">
                                    <strong>Términos y condiciones</strong>
                                    <p>
                                        Válido en ambas sucursales al mostrar su número de membresía e identificación. Aplica para ventas externas y no hospitalarias o urgencias. No acumulable con otras promociones.
                                    </p>
                                    <p>
                                        Urgencias: Aplica para titular e hijos presentando identificación. No incluye estudios clínicos ni valoración por especialistas.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section pb-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-6">
                            <div className="position-relative text-center">
                                <h5 className="fw-semibold">¿Cómo puedo obtener mi tarjeta Aranda+?</h5>
                                Inscríbete ahora y aprovecha estos beneficios diseñados para tu bienestar y el de tu familia.
                                <br />
                                <a href="#registro" className='btn btn-success my-4'>Registro</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section bg-pink pt-3 pb-0">
                <div className="container">
                    <div className="row justify-content-center my-0 py-0">
                        <div className="col-12 text-center my-4">
                            <img src={icon} className="img-fluid slidericon mx-auto" alt="" />
                        </div>
                        <div className="col-12 col-sm-8 text-center mb-0">
                            <img src={arandacard} alt="Aranda +" className='img-fluid w-75' />
                        </div>
                    </div>
                </div>
            </section>
            <section className="section bg-light" id='registro'>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-md-6 col-12">
                            <div className="p-4 bg-white rounded shadow-md mx-auto w-100 text-center">
                                <form onSubmit={handleSubmit}>
                                    <h6 className="mb-3 text-uppercase fw-semibold text-center">Regístrese a nuestro programa de beneficios Aranda +</h6>
                                    <div className="row mt-4">
                                        <div className="col-md-3 mb-3 text-start">
                                            <label className="form-label fw-semibold">Nombre <span className='text-danger'>*</span></label>
                                            <input name="firstname" id="firstname" type="text" className="form-control border-primary" placeholder="Su nombre" defaultValue={registrationError ? registrationInfo?.firstname : ''} onInput={handleSanitizedInput} />
                                        </div>
                                        <div className="col-md-3 mb-3 text-start">
                                            <label className="form-label fw-semibold">Segundo nombre</label>
                                            <input name="secondname" id="secondname" type="text" className="form-control border-primary" placeholder="Segundo nombre" defaultValue={registrationError ? registrationInfo?.secondname : ''} onInput={handleSanitizedInput} />
                                        </div>
                                        <div className="col-md-3 mb-3 text-start">
                                            <label className="form-label fw-semibold">Apellido paterno <span className='text-danger'>*</span></label>
                                            <input name="lastname" id="lastname" type="text" className="form-control border-primary" placeholder="Apellido paterno" defaultValue={registrationError ? registrationInfo?.lastname : ''} onInput={handleSanitizedInput} />
                                        </div>
                                        <div className="col-md-3 mb-3 text-start">
                                            <label className="form-label fw-semibold">Apellido materno</label>
                                            <input name="secondlastname" id="secondlastname" type="text" className="form-control border-primary" placeholder="Apellido materno" defaultValue={registrationError ? registrationInfo?.secondlastname : ''} onInput={handleSanitizedInput} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 mb-3 text-start">
                                            <label className="form-label fw-semibold">Su Email <span className='text-danger'>*</span></label>
                                            <input name="email" id="email" type="email" className="form-control border-primary" placeholder="Correo electrónico" defaultValue={registrationError ? registrationInfo?.email : ''} onInput={(e) => { handleEmailInput(e); handleSanitizedInput(e); }} onBlur={handleEmailBlur} />
                                            <div className="invalid-feedback">
                                                Por favor, ingrese una dirección de correo electrónico válida.
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-3 text-start">
                                            <label className="form-label fw-semibold">Su Email (confirmación) <span className='text-danger'>*</span></label>
                                            <input name="email_confirmation" id="email_confirmation" type="email" className="form-control border-primary" placeholder="Correo electrónico (nuevamente)" defaultValue={registrationError ? registrationInfo?.email_confirmation : ''} onInput={(e) => { handleEmailInput(e); handleSanitizedInput(e); }} onBlur={handleEmailBlur} />
                                            <div className="invalid-feedback">
                                                Por favor, ingrese una dirección de correo electrónico válida.
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-3 text-start">
                                            <label className="form-label fw-semibold">Teléfono a 10 dígitos<span className='text-danger'>*</span></label>
                                            <input name="tel" id="tel" type="tel" className="form-control border-primary" placeholder="Su móvil" defaultValue={registrationError ? registrationInfo?.tel : ''} onInput={(e) => { handlePhoneInput(e); handleSanitizedInput(e); }} />
                                        </div>
                                    </div>
                                    <div className="form-check mb-3 text-start d-flex gap-3 justify-content-center">
                                        <input className="form-check-input border-primary" type="checkbox" value="" id="flexCheckDefault" onChange={handleCheckboxChange} />
                                        <label className="form-label form-check-label text-muted" htmlFor="flexCheckDefault">Acepto que he leido el <Link to="/aviso-privacidad" target='_blank' className="text-primary">Aviso de Privacidad</Link></label>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <Turnstile siteKey={TURNSTILE_KEY} onSuccess={handleCallBackTurnstile} onExpire={handleExpirationTurnstile} />
                                        </div>
                                    </div>
                                    {captchaPassed && !isLoading && (
                                        <button className="btn btn-primary w-50 mt-4" type="submit" disabled={!isChecked}>Registro</button>
                                    )}
                                    {isLoading && (
                                        <div className="spinner-border text-success mx-auto my-2 text-center" role="status">
                                            <span className="visually-hidden text-center">Enviando, espere...</span>
                                        </div>
                                    )}
                                    {errorDelivering && (
                                        <>
                                            <br />
                                            <div className="alert alert-warning text-dark alert-dismissible fade show mt-4" role="alert">
                                                <strong>No se pudo realizar el registro, revise lo siguiente: </strong> {errorDeliveringMessage}
                                            </div>
                                        </>
                                    )}
                                    {successDelivering && (
                                        <>
                                            <br />
                                            <div className="alert alert-success alert-dismissible fade show mt-4" role="alert">
                                                <strong>{successDeliveringMessage}</strong>
                                            </div>
                                        </>
                                    )}
                                    <div className="col-12 text-center mt-3">
                                        <span><span className="text-muted small me-2">¿Ya tiene una cuenta? </span> <Link to="/login" className="text-dark fw-semibold small">Iniciar sesión</Link></span>
                                    </div>
                                    <hr className='w-50 mx-auto mt-5 border-muted' />
                                    <div className="col-12 text-center text-muted mt-5 small">
                                        <LuInfo /> <strong>Nota:</strong> Todos los campos marcados con <span className='text-danger'>*</span> son obligatorios.
                                        <br />
                                        Al finalizar el registro, recibirá un correo electrónico con su contraseña, asegúrese de utilizar un correo electrónico válido, así como de revisar su bandeja de entrada y correo no deseado.
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="section bg-light">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-6">
                            <div className="position-relative text-center">
                                <h5 className="fw-semibold">¿Cómo puedo obtener mi tarjeta Aranda+?</h5>
                                Inscríbete ahora y aprovecha estos beneficios diseñados para tu bienestar y el de tu familia.
                                <br />
                                <h4 className='text-primary'>¡Es rápido, fácil y totalmente gratuito!</h4>
                                <a href="/registro" className='btn btn-success my-4'>Registro</a>
                                <br />
                                Ya tienes una cuenta? <Link to="/login" className="text-secondary">Inicia sesión</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            <Footer />

            <ScrollToTop />
        </div>
    )
}
